<script>
import getErrorMessage from '@/modules/server-errors';

//
// NOTE: This component is intentionally not translated.
//

export default {
  name: 'UpgradeDialog',
  data() {
    return {
      cardNumber: '',
      cvc: '',
      dialogVisible: false,
      expiration: '',
      isSubmitting: false,
      paymentInterval: 'month',
      plan: 'business',
      stripe: null,
      stripeCard: null
    };
  },
  methods: {
    show(options) {
      options = options || {};
      this.plan = options.plan || 'business';
      this.paymentInterval = options.paymentInterval || 'month';
      this.cardNumber = '';
      this.cvc = '';
      this.dialogVisible = true;
      this.expiration = '';
      this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

      // Create the Stripe credit card input
      if (!this.stripeCard) {
        this.$nextTick(() => {
          const elements = this.stripe.elements();
          this.stripeCard = elements.create('card', {
            style: {
              base: {
                fontFamily:
                  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '14px',
                '::placeholder': {
                  color: '#a6adb2' // $--color-gray-40
                },
                color: '#2e3235' // $--color-gray-90
              },
              invalid: {
                color: '#fa5555', // $--color-danger
                iconColor: '#fa5555' // $--color-danger
              }
            }
          });
          this.stripeCard.mount('#upgrade-cc-input');
          this.stripeCard.on('ready', () => this.stripeCard.focus());
        });
      } else {
        this.$nextTick(() => {
          this.stripeCard.clear();
          this.stripeCard.focus();
        });
      }
    },

    hide() {
      this.dialogVisible = false;
    },

    handleSubmit() {
      this.isSubmitting = true;
      this.stripe.createToken(this.stripeCard).then(result => {
        if (result.error) {
          this.isSubmitting = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            message: result.error.message
          });
        } else {
          this.$http
            .post('/account/subscription', {
              plan: this.plan,
              paymentInterval: this.paymentInterval,
              token: result.token
            })
            .then(res => {
              this.account = res.data.account;
              this.$store.commit('setAccount', this.account);
              this.hide();
            })
            .catch(err => {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: getErrorMessage(err.response.data.code)
              });
            })
            .finally(() => (this.isSubmitting = false));
        }
      });
    }
  }
};
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="Upgrade"
    class="upgrade-dialog"
  >
    <el-form
      ref="form"
      @submit="handleSubmit"
    >
      <el-row :gutter="20">
        <el-col :span="14">
          <!-- Plan -->
          <el-form-item>
            <el-select
              v-model="plan"
              placeholder=""
            >
              <el-option label="Business" value="business" />
              <el-option label="Agency" value="agency" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <!-- Payment interval -->
          <el-form-item>
            <el-select
              v-model="paymentInterval"
              placeholder=""
            >
              <el-option v-if="plan === 'business'" label="$12/month" value="month" />
              <el-option v-if="plan === 'business'" label="$120/year" value="year" />
              <el-option v-if="plan === 'agency'" label="$24/month" value="month" />
              <el-option v-if="plan === 'agency'" label="$240/year" value="year" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- Stripe Elements input -->
      <div id="upgrade-cc-input" />
      <small class="text-form-description">
        Payments are processed securely by Stripe.
      </small>
    </el-form>

    <!-- Footer -->
    <span slot="footer">
      <el-button
        :loading="isSubmitting"
        type="primary"
        @click="handleSubmit"
      >
        Submit Payment
      </el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.upgrade-dialog {
  /deep/ .el-dialog {
    width: 25rem;

    .el-dialog__body > :last-child {
      margin-bottom: 0;
    }

    .el-dialog__footer {
      position: relative;

      .el-button {
        width: 100%;
        padding: 1rem;
      }
    }
  }

  form {
    margin-bottom: 2rem;

    .StripeElement {
      position: relative;
      background: $--color-white;
      border-radius: 0.25rem;
      border: solid 1px $--input-border-color;
      padding: 0.6rem 0.6rem 0.7rem 0.6rem;
      margin-bottom: 0.5rem;
      transition: 0.1s border-color;

      &.StripeElement--focus {
        border: solid 1px $--color-primary-light-7;
      }
    }

    &::after,
    &::before {
      bottom: 100%;
      left: 1.75rem;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }
  }
}
</style>
